import { RiskDataService } from "@app/risk/services/RiskDataService";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Observable } from "rxjs";
import { Component, Input, OnInit, inject } from "@angular/core";
import { RendererType } from "@enums/RendererType";
import { RendererConfig } from "@models/workspace/RendererConfig";
import { ModuleType } from "@enums/ModuleType";
import { SearchKeyword } from "@models/workspace/SearchKeyword";
import { nameof } from "@methods/jeffs-toolkit";
import { FilterType } from "@enums/FilterType";
import { RiskLinkModel } from "@models/risk/RiskLinkModel";
import { FilterConfig } from "@models/workspace/FilterConfig";
import { injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/risk/i18n/scope";
import { LinkableComponent } from "@app/shared/linkable/linkable.component";

@Component({
    selector: "risk-linkable",
    templateUrl: "./risk-linkable.component.html",
    styleUrls: ["./risk-linkable.component.scss"],
    imports: [LinkableComponent],
    viewProviders: [provideTranslationScope(scope)],
})
export class RiskLinkableComponent extends ItemLinkableBase implements OnInit {
    @Input() moduleType = ModuleType.ORM;

    @Input() typename = "risks";
    @Input() activeFilters: SearchKeyword[] = [];
    @Input() showAdvancedFilters = false;

    hasAccessChecks = {};
    accessCheckInProgress = false;

    filterConfig: FilterConfig[] = [
        {
            label: "Organizations",
            column: nameof<RiskLinkModel>((x) => x.organizationId),
            type: FilterType.Organization,
            hideActionColumn: true,
            param: "",
        },
        {
            label: "Business Dimensions",
            column: nameof<RiskLinkModel>((x) => x.businessDimensionIds),
            type: FilterType.BusinessDimensions,
            hideActionColumn: true,
            param: "",
        },
        {
            label: "Framework Dimensions",
            column: nameof<RiskLinkModel>((x) => x.frameworkDimensionIds),
            type: FilterType.FrameworkDimensions,
            hideActionColumn: true,
            param: "",
        },
    ];

    numberProperties = ["Gross score", "Net score"];
    rendererConfig: RendererConfig[] = [
        {
            textColumn: "Gross score",
            actionColumn: "GrossScoreColor",
            hideActionColumn: true,
            type: RendererType.Score,
        },
        {
            textColumn: "Net score",
            actionColumn: "NetScoreColor",
            hideActionColumn: true,
            type: RendererType.Score,
        },
    ];

    private _riskDS = inject(RiskDataService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _translation = injectTranslation(scope);

    async ngOnInit(): Promise<void> {
        await this._translation.ready();
        this.filterConfig[0].label = this._translation.t("riskLinkable.filterOrganizations");
        this.filterConfig[1].label = this._translation.t("riskLinkable.filterBusinessDimensions");
        this.filterConfig[2].label = this._translation.t("riskLinkable.filterFrameworkDimensions");
    }

    hasAccessToItem(guid: string): Observable<boolean> {
        return this._riskDS.hasAccessToRisk(guid);
    }

    async openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess === true) {
            this._tabService.generateTab(
                this._pages.RiskDetail,
                item.guid,
                `(R) ${item[this.displayValueProp]}`,
            );
        } else {
            // t() needs the scope loaded first; before ready() it throws in development.
            await this._translation.ready();
            this._toastr.warning(
                this._translation.t("riskLinkable.notEnoughRights"),
            );
        }
    }
}
